export default __webpack_public_path__ + "static/media/reading-modal-image.f11699fa.png";